import { useState } from 'react';
import { UserManagementListing, AddPvxUserView } from './components';
import EditCompany from './components/EditCompany';
import { ClientTableRow } from './hooks/useClientsTable';
import { UserManagementScreen, UserManagementTabs } from './constants';
import { AddPvxPartner } from './components/AddPvxPartner';

export { UserManagementScreen };

export type ScreenState =
  | { screen: UserManagementScreen.LISTING }
  | { screen: UserManagementScreen.EDIT_COMPANY; company: ClientTableRow }
  | { screen: UserManagementScreen.ADD_PVX_USER }
  | { screen: UserManagementScreen.EDIT_PVX_USER; userId: string }
  | { screen: UserManagementScreen.CLONE_PVX_USER; userId: string }
  | { screen: UserManagementScreen.ADD_PVX_PARTNER }
  | { screen: UserManagementScreen.EDIT_PVX_PARTNER; clientCode: string };

const UserManagementPage = () => {
  const [screenState, setScreenState] = useState<ScreenState>({
    screen: UserManagementScreen.LISTING,
  });
  const [selectedTab, setSelectedTab] = useState<UserManagementTabs>(UserManagementTabs.CLIENTS);

  const goToListing = () => setScreenState({ screen: UserManagementScreen.LISTING });

  const renderContent = () => {
    switch (screenState.screen) {
      case UserManagementScreen.EDIT_COMPANY:
        return <EditCompany onBack={goToListing} company={screenState.company} />;

      case UserManagementScreen.ADD_PVX_PARTNER:
        return <AddPvxPartner onBack={goToListing} />;

      case UserManagementScreen.EDIT_PVX_PARTNER:
        return <AddPvxPartner onBack={goToListing} clientCode={screenState.clientCode} />;

      case UserManagementScreen.ADD_PVX_USER:
        return <AddPvxUserView mode="add" onBack={goToListing} />;

      case UserManagementScreen.EDIT_PVX_USER:
        return <AddPvxUserView mode="edit" userId={screenState.userId} onBack={goToListing} />;

      case UserManagementScreen.CLONE_PVX_USER:
        return <AddPvxUserView mode="clone" userId={screenState.userId} onBack={goToListing} />;

      case UserManagementScreen.LISTING:
        return (
          <UserManagementListing
            onNavigate={setScreenState}
            selectedTab={selectedTab}
            setSelectedTab={setSelectedTab}
          />
        );
      default:
        return null;
    }
  };
  return renderContent();
};

export default UserManagementPage;
